export default {
  baseStyle: {
    _focus: {
      boxShadow: 'none',
    },
  },
}
